import React from "react";
import "./Nurturing.css"; // Assuming you have a CSS file for styling

const Nurturing = () => {
  return (
    <div>
      {/* <!-- Start Hero --> */}
      <section class="common-page-hero">
        <img
          src="assets/img/service/s11.png"
          class="common-hero-bg ak-bg"
          alt="..."
        />
        <div class="common-hero-content">
          <div class="common-hero-info">
            <div class="ak-section-heading ak-style-1 animation-title-content animation-style3">
              <p
                class="ak-section-subtitle animation-title"
                style={{ color: "white" }}
              >
                {" "}
                Courses
              </p>
              <h2
                class="ak-section-title animation-title"
                style={{ fontSize: "45px", color: "white" }}
              >
                SEMANTIC Skills Junction: Bridging Talent and Technology
              </h2>
            </div>
            <p class="back-btn" style={{ color: "white" }}>
              <a href="/">Home</a> / Course
            </p>
          </div>
          <a href="" class="phone-number" style={{ color: "white" }}>
            (+91) 7619617023
          </a>
        </div>
      </section>
      {/* <!-- End Hero --> */}
      {/* <!-- Start Service --> */}

      {/* <div class="ak-height-75 ak-height-lg-50"></div> */}
      <section>
        <div className="container" style={{ marginTop: "20px" }}>
          <div className="ak-section-heading ak-style-1 animation-title-content animation-style3">
            <h3
              className="ak-section-title animation-title"
              style={{ fontSize: "40px", perspective: "400px" }}
            >
              <div
                className="split-line"
                style={{
                  display: "block",
                  textAlign: "start",
                  position: "relative",
                }}
              >
                <div style={{ position: "relative", display: "inline-block" }}>
                  {"NURTURING".split("").map((char, idx) => (
                    <div
                      key={`nurturing-${idx}`}
                      style={{
                        position: "relative",
                        display: "inline-block",
                        transform: "translate(0px, 0px)",
                        opacity: 1,
                      }}
                    >
                      {char}
                    </div>
                  ))}
                </div>{" "}
                <div style={{ position: "relative", display: "inline-block" }}>
                  {"WAFER".split("").map((char, idx) => (
                    <div
                      key={`wafer-${idx}`}
                      style={{
                        position: "relative",
                        display: "inline-block",
                        transform: "translate(0px, 0px)",
                        opacity: 1,
                      }}
                    >
                      {char}
                    </div>
                  ))}
                </div>{" "}
                <div style={{ position: "relative", display: "inline-block" }}>
                  {"FAB".split("").map((char, idx) => (
                    <div
                      key={`fab-${idx}`}
                      style={{
                        position: "relative",
                        display: "inline-block",
                        transform: "translate(0px, 0px)",
                        opacity: 1,
                      }}
                    >
                      {char}
                    </div>
                  ))}
                </div>{" "}
                <div style={{ position: "relative", display: "inline-block" }}>
                  {"OSAT".split("").map((char, idx) => (
                    <div
                      key={`osat-${idx}`}
                      style={{
                        position: "relative",
                        display: "inline-block",
                        transform: "translate(0px, 0px)",
                        opacity: 1,
                      }}
                    >
                      {char}
                    </div>
                  ))}
                </div>{" "}
                <div style={{ position: "relative", display: "inline-block" }}>
                  {"NEWHIRES".split("").map((char, idx) => (
                    <div
                      key={`newhires-${idx}`}
                      style={{
                        position: "relative",
                        display: "inline-block",
                        transform: "translate(0px, 0px)",
                        opacity: 1,
                      }}
                    >
                      {char}
                    </div>
                  ))}
                </div>
              </div>
            </h3>

            <div className="strategic-points">
              <div className="points-card">
                <div className="points-container">
                  <div className="point-item">
                    <span className="bullet">➤</span>
                    <p style={{ marginBottom: "10px",fontWeight:"bold",color:"red" }}>
                      <span className="highlight">
                        Transforms New Hires into Fully Trained and Certified
                        Line Personnel
                      </span>
                    </p>
                  </div>
                  <div className="point-item">
                    <span className="bullet">➤</span>
                    <p className="content" style={{fontWeight:"bold"}}>
                      Duration: <span className="highlight" style={{ color:"red" }}>15 weeks</span>.
                    </p>
                  </div>
                  <div className="point-item">
                    <span className="bullet">➤</span>
                    <p className="content" style={{fontWeight:"bold"}}>
                      Includes <span className="highlight" style={{ color:"red" }}>Classroom</span> and{" "}
                      <span className="highlight" style={{ color:"red" }}>On-Job Training</span> [OJT]
                    </p>
                  </div>
                  <div className="point-item">
                    <span className="bullet">➤</span>
                    <p className="content" style={{fontWeight:"bold"}}>
                      Applicable to{" "}
                      <span className="highlight" style={{ color:"red" }}>
                        Engineers, Associate Engineers, and Technicians
                      </span>{" "}
                      across multiple job scopes – Modules Process, Equipment,
                      Technology Development / Integration / Product/Test,
                      Manufacturing, Facilities, Quality
                    </p>
                  </div>

                  <div className="point-item">
                    <span className="bullet">➤</span>
                    <p className="content" style={{fontWeight:"bold"}}>
                      Offered in{" "}
                      <span className="highlight" style={{ color:"red" }}>
                        close collaboration with Factory Transfer Team, Mother
                        Fab, Technology Providers and Tool Vendors
                      </span>
                      .
                    </p>
                  </div>

                  <div className="point-item">
                    <span className="bullet">➤</span>
                    <p className="content" style={{fontWeight:"bold"}}>
                      Fully customized to individual Wafer Fab, OSAT
                      requirements.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <p className="ak-section-desp" style={{ textAlign: "justify" }}>
              Our program is designed to bridge the gap between new hires and
              the requirements of high-performing wafer fab and OSAT
              environments. By integrating classroom instruction and on-the-job
              training (OJT), we prepare engineers, associate engineers and
              technicians for critical roles across multiple job scopes. This
              comprehensive training program transforms new hires into fully
              trained and certified personnel through a combination of classroom
              sessions and on-job training (OJT). It equips participants with
              the essential skills needed for success in wafer fab and advanced
              packaging industries.
            </p>
          </div>

          <div className="ak-height-50 ak-height-lg-30"></div>

          <div className="image-hov-one">
            <img
              className="img-fluid"
              src="assets/img/service/m42.jpeg"
              alt="Training Program"
              style={{ marginRight: "20px" }}
            />
          </div>
        </div>
      </section>
      {/* <!-- End Service Details --> */}

      {/* <!-- Start Team --> */}
      {/* <div class="ak-height-125 ak-height-lg-80"></div> */}
      <section>
        <div class="container">
          <div class="ak-section-heading-content">
            <div class="ak-section-heading ak-style-1 animation-title-content animation-style3 ak-w-60">
              <p
                class="ak-section-subtitle animation-title"
                style={{ marginTop: "20px", fontSize: "20px" }}
              >
                Program Structure
              </p>
              {/* <h2 class="ak-section-title animation-title" style={{fontSize:'25px'}}>
                    Comprehensive training program to prepare you for a successful career in semiconductor fabrication
                    </h2> */}
            </div>
          </div>
          <h3
            class="ak-section-title animation-title"
            style={{ fontSize: "35px", textAlign: "center", marginTop: "10px" }}
          >
            Introduction to Semiconductor Fabrication
          </h3>
          <h2 style={{ fontSize: "25px", marginTop: "20px" }}>
            A foundational training program designed to equip you with the
            knowledge and skills essential for excelling in semiconductor
            manufacturing and advanced packaging processes.
          </h2>
          {/* <div class="ak-height-60 ak-height-lg-50"></div> */}
          <div class="ak-slider ak-team-slider">
            <div class="swiper-wrapper" style={{ marginTop: "20px" }}>
              <div class="swiper-slide">
                <a href="/nurturing" class="team-card style-two h-100">
                  <div class="team-thamnel">
                    <img src="./assets/img/service/n1.jpeg" alt="..." />
                    <div class="img-overlay"></div>
                    {/* <div class="team-card-btn">
                                    <span class="btn-text">View More</span>
                                    <span class="icon-arrow">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="13"
                        height="12"
                        viewBox="0 0 13 12"
                        fill="none"
                      >
                        <path
                          d="M1.0874 9.49938L11.9127 3.24938M11.9127 3.24938L3.71657 1.05322M11.9127 3.24938L9.71657 11.4455"
                          stroke="#030917"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                                </div> */}
                  </div>
                  <div class="team-body">
                    <div class="team-info">
                      <h5 class="title">Advanced Learning</h5>
                      <p class="short-title" style={{ textAlign: "justify" }}>
                        Dive into the future of wafer fabs with in-depth
                        training on photolithography, the advanced packaging,
                        and emerging technologies.
                      </p>
                    </div>
                  </div>
                </a>
              </div>
              <div class="swiper-slide">
                <a href="/nurturing" class="team-card style-two h-100">
                  <div class="team-thamnel">
                    <img src="./assets/img/service/n2.jpeg" alt="..." />
                    <div class="img-overlay"></div>
                    {/* <div class="team-card-btn">
                                    <span class="btn-text">View More</span>
                                    <span class="icon-arrow">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="13"
                        height="12"
                        viewBox="0 0 13 12"
                        fill="none"
                      >
                        <path
                          d="M1.0874 9.49938L11.9127 3.24938M11.9127 3.24938L3.71657 1.05322M11.9127 3.24938L9.71657 11.4455"
                          stroke="#030917"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                                </div> */}
                  </div>
                  <div class="team-body">
                    <div class="team-info">
                      <h5 class="title">Industry-Relevant Skills</h5>
                      <p class="short-title" style={{ textAlign: "justify" }}>
                        Equip yourself with practical skills through real-world
                        On-Job Training (OJT) and collaborations with industry
                        leaders.
                      </p>
                    </div>
                  </div>
                </a>
              </div>
              <div class="swiper-slide">
                <a href="/nurturing" class="team-card style-two h-100">
                  <div class="team-thamnel">
                    <img src="./assets/img/service/n4.png" alt="..." />
                    <div class="img-overlay"></div>
                    {/* <div class="team-card-btn">
                                    <span class="btn-text">View More</span>
                                    <span class="icon-arrow">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="13"
                        height="12"
                        viewBox="0 0 13 12"
                        fill="none"
                      >
                        <path
                          d="M1.0874 9.49938L11.9127 3.24938M11.9127 3.24938L3.71657 1.05322M11.9127 3.24938L9.71657 11.4455"
                          stroke="#030917"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                                </div> */}
                  </div>
                  <div class="team-body">
                    <div class="team-info">
                      <h5 class="title">Role-Specific Expertise</h5>
                      <p class="short-title" style={{ textAlign: "justify" }}>
                        Receive tailored training for Engineers, Technicians and
                        Associate Engineers in process, equipment and product
                        integration.
                      </p>
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <div
              class="service-swiper-controller"
              style={{ marginLeft: "1200px" }}
            >
              <button class="service-next-btn slider-btn next">
                <svg
                  width="10"
                  height="18"
                  viewBox="0 0 10 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.00928 0.73999L1.00928 8.73999L9.00928 16.74"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
              <button class="service-prev-btn slider-btn prev">
                <svg
                  width="10"
                  height="18"
                  viewBox="0 0 10 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.00928 0.73999L9.00928 8.73999L1.00928 16.74"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- Start Testmonial --> */}
      {/* <div class="ak-height-125 ak-height-lg-80"></div> */}
      <section>
        <div class="container">
          <div class="testmonial-top-content">
            <div class="ak-section-heading ak-style-1 animation-title-content animation-style3">
              {/* <p class="ak-section-subtitle animation-title">Feedback</p> */}
              <h2
                class="ak-section-title animation-title"
                style={{ fontSize: "40px" }}
              >
                Step into the Future of Nurturing Wafer Fab OSAT
              </h2>
            </div>
            {/* <div class="testmonial-top-desp">
                The semiconductor industry is at the forefront of technological innovation, driving advancements in key areas such as 5G, Artificial Intelligence (AI), Robotics, IoT, Automotive technology, and High-Performance Computing (HPC). Here's an overview of the market's tremendous growth potential:
                </div> */}
          </div>
          {/* <div class="ak-height-60 ak-height-lg-50"></div> */}
          <div class="testmonial-content ak-slider ak-slider-testmonial">
            <div class="swiper-wrapper" style={{ marginTop: "20px" }}>
              <div class="swiper-slide">
                <div class="testmonial-slider">
                  <div class="testmonial-img">
                    <img
                      src="./assets/img/service/new1.png"
                      data-swiper-parallax="200"
                      alt="..."
                    />
                  </div>
                  <div class="testmonial-info">
                    <p class="testmonial-shot-title">
                      India Semiconductor Mission: Empowering the Industry
                    </p>
                    <div class="ak-height-40 ak-height-lg-30"></div>
                    <h3 class="testmonial-title" style={{ fontSize: "23px" }}>
                      <strong>Program Highlights:</strong> <br />
                      <br />
                      <ul
                        style={{
                          fontSize: "20px",
                          textAlign: "justify",
                          lineHeight: "1.5",
                        }}
                      >
                        <li>
                          <strong>Duration:</strong> 15 weeks of intensive
                          training, combining theoretical knowledge with
                          practical application.
                        </li>
                        <li>
                          <strong>Training Format:</strong>
                          <ul>
                            <li>
                              <strong>Classroom Sessions:</strong> In-depth
                              theoretical learning to build a strong foundation.
                            </li>
                            <li>
                              <strong>On-Job Training (OJT):</strong> Hands-on
                              experience in real-world scenarios to ensure job
                              readiness.
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </h3>
                    <div class="ak-height-50 ak-height-lg-30"></div>
                    {/* <div class="person-info">
                                    <div>
                                        <p class="name">Andrew Taylor</p>
                                        <p class="form">From USA</p>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="43" height="38" viewBox="0 0 43 38" fill="none">
                        <path
                          d="M19.2291 14.229C19.2291 20.8709 17.6233 26.0703 14.4117 29.8272C11.2 33.5841 6.68822 36.0531 0.876244 37.2343V30.4171C5.28972 29.064 8.25971 26.6176 9.7862 23.078C10.6236 21.3935 10.9863 19.5127 10.8351 17.6376H0.548283L0.548283 0.39867L19.2291 0.39867V14.229ZM42.9883 14.229C42.9883 20.7836 41.4261 25.962 38.3018 29.7642C35.1775 33.5664 30.6221 36.0571 24.6354 37.2363V30.4191C29.0929 29.0193 32.0862 26.6159 33.6154 23.209C34.3942 21.4604 34.7318 19.5472 34.5983 17.6376L24.3075 17.6376V0.39867H42.9883L42.9883 14.229Z"
                          fill="#485B60"
                        />
                      </svg>
                                    </div>
                                </div> */}
                  </div>
                </div>
              </div>
              {/* <div class="swiper-slide">
                        <div class="testmonial-slider">
                            <div class="testmonial-img">
                                <img src="./assets/img/bg/bg6.png" data-swiper-parallax="200" alt="..." />
                            </div>
                            <div class="testmonial-info">
                                <p class="testmonial-shot-title">
                                Growing Demand and Key Industry Players
                                </p>
                                <div class="ak-height-40 ak-height-lg-30"></div>
                                <h4 class="testmonial-title" style={{fontSize:'28px'}}>
                              <strong>Additional Features:</strong>
      <ul>
        <li>Orientation visit to a Fab Cleanroom</li>
        <li>Includes industry relevant videos</li>
        <li>Delivery Mode: Face-to-Face</li>
      </ul>
   
                                </h4>
                                <div class="ak-height-50 ak-height-lg-30"></div>
                               
                            </div>
                        </div>
                    </div> */}
            </div>
            <div class="testmonial-controller">
              {/* <div class="testmonial-swiper-controller">
                        <button class="testmonial-next-btn slider-btn next">
                <svg
                  width="10"
                  height="18"
                  viewBox="0 0 10 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.00928 0.73999L1.00928 8.73999L9.00928 16.74"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
                        <button class="testmonial-prev-btn slider-btn prev">
                <svg
                  width="10"
                  height="18"
                  viewBox="0 0 10 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.00928 0.73999L9.00928 8.73999L1.00928 16.74"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
                    </div> */}
              {/* <div>
                        <p class="ak-black-color mb-0 ak-medium">350+ Over</p>
                        <p class="ak-font-16 mb-0">User Feedback</p>
                    </div> */}
            </div>
          </div>
        </div>
      </section>
      {/* <!-- End Testmonial --> */}

      {/* <!-- Start Feature --> */}
      {/* <div class="ak-height-100 ak-height-lg-50"></div> */}
      <h3
        class="ak-section-title animation-title"
        style={{ fontSize: "35px", textAlign: "center", marginTop: "10px" }}
      >
        Transforming New Hires into Fully Trained and Certified Line Personnel
      </h3>

      <div className="image-hov-one" style={{ marginLeft: "120px" }}>
        <img className="img-fluid" src="assets/img/service/ss1.png" alt="..." />
      </div>

      {/* <h2  style={{fontSize:'15px',marginTop:'20px' ,textAlign:'center'}}>
                This program equips candidates with advanced skills in DFT and analog circuit design, offering an industry-aligned curriculum, hands-on training, and certifications. Graduates are prepared for key roles like Wafer Fab Process Engineer, Quality Engineer, and more in the IC design and manufacturing industry
                    </h2> */}
      <section class="container">
        <div class="feature-content gap-2" style={{ marginTop: "10px" }}>
          <div class="feature-card">
            <img
              class="feature-icon"
              src="./assets/img/icon/ok-sign.svg"
              alt="..."
            />
            <div class="feature-body">
              <h5 class="feature-title">Prerequisites</h5>
              <p style={{ textAlign: "justify" }}>
                To ensure a successful learning journey, candidates should meet
                the following prerequisites:
                <strong>background in Engineering or Science</strong> in fields
                such as
              </p>
              <ul>
                <li>Electronics</li>
                <li>Electrical</li>
                <li>Mechanical</li>
                <li>Chemical Engineering</li>
                <li>Physics or Material Science</li>
              </ul>
            </div>
          </div>
          <div class="ak-feature-hr ak-h-100"></div>
          <div class="feature-card">
            <img
              class="feature-icon"
              src="assets/img/icon/ok-sign.svg"
              alt="..."
            />
            <div class="feature-body">
              <h5 class="feature-title">Program Benefits</h5>
              <p style={{ textAlign: "justify" }}>
                This program transforms new hires into highly skilled, certified
                line personnel with: Combines classroom learning with On-Job
                Training (OJT) for practical exposure.
              </p>
              <ul>
                {/* <li>Industry-aligned curriculum</li> */}
                <li>Comprehensive Training</li>
                <li>Role-Specific Skills</li>
                <li>Collaboration Opportunities</li>
                <li>Tailored Curriculum</li>
                <li>Industry-standard certifications</li>
              </ul>
            </div>
          </div>
          <div class="ak-feature-hr ak-h-100"></div>
          <div class="feature-card">
            <img
              class="feature-icon"
              src="assets/img/icon/ok-sign.svg"
              alt="..."
            />
            <div class="feature-body">
              <h5 class="feature-title">Career Opportunities</h5>
              <p style={{ textAlign: "justify" }}>
                This training program opens doors to high-demand roles in the
                semiconductor and advanced packaging industry, such as:
              </p>
              <ul>
                <li>Wafer Fab Process Engineer</li>
                <li>Quality Engineer</li>
                <li>Equipment Engineer</li>
                <li>Process Integration Engineer</li>
                <li>Yield Enhancement Engineer</li>
                <li>Reliability Test Engineer</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <span class="ak-scrollup">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 10L1.7625 11.7625L8.75 4.7875V20H11.25V4.7875L18.225 11.775L20 10L10 0L0 10Z"
            fill="currentColor"
          />
        </svg>
      </span>
    </div>
  );
};

export default Nurturing;
